import { useCallback, useMemo, useState } from 'react';
import {
  buildSiteListStats,
  DEFAULT_SITE_LIST_FILTERS,
  filterSites,
  hasSiteListFilters
} from '../components/sites/siteListUtils';

export function useSiteListFilters(sites) {
  const [search, setSearch] = useState(DEFAULT_SITE_LIST_FILTERS.search);
  const [statusFilter, setStatusFilter] = useState(DEFAULT_SITE_LIST_FILTERS.statusFilter);
  const [careModeFilter, setCareModeFilter] = useState(DEFAULT_SITE_LIST_FILTERS.careModeFilter);

  const filters = useMemo(
    () => ({ search, statusFilter, careModeFilter }),
    [search, statusFilter, careModeFilter]
  );

  const filteredSites = useMemo(() => filterSites(sites, filters), [sites, filters]);

  const stats = useMemo(
    () => buildSiteListStats(filteredSites, sites.length, filters),
    [filteredSites, sites.length, filters]
  );

  const hasActiveFilters = useMemo(() => hasSiteListFilters(filters), [filters]);

  const clearFilters = useCallback(() => {
    setSearch(DEFAULT_SITE_LIST_FILTERS.search);
    setStatusFilter(DEFAULT_SITE_LIST_FILTERS.statusFilter);
    setCareModeFilter(DEFAULT_SITE_LIST_FILTERS.careModeFilter);
  }, []);

  return {
    search,
    setSearch,
    statusFilter,
    setStatusFilter,
    careModeFilter,
    setCareModeFilter,
    filteredSites,
    stats,
    hasActiveFilters,
    clearFilters,
    filters
  };
}

export default useSiteListFilters;
